import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function MixedSequencesPreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>W zadaniach mieszanych najpierw rozpoznajemy, z którego warunku należy skorzystać.</p>
      <p><strong>Ciąg arytmetyczny:</strong> stała jest różnica sąsiednich wyrazów.</p>
      <BlockMath math={String.raw`a_{n+1}-a_n=r\qquad a_n=\frac{a_{n-1}+a_{n+1}}{2}`} />
      <p><strong>Ciąg geometryczny:</strong> stały jest iloraz sąsiednich niezerowych wyrazów.</p>
      <BlockMath math={String.raw`\frac{a_{n+1}}{a_n}=q\qquad a_n^2=a_{n-1}\cdot a_{n+1}`} />
      <p>
        Przy własności geometrycznej pamiętamy o znaku: bez dodatkowych założeń równanie
        może mieć dwa rozwiązania, a warunek dodatniości pozostawia tylko dodatnie.
      </p>
      <p>
        Jeżeli wyrazy są opisane innym wzorem, najpierw obliczamy ich wartości,
        a dopiero potem nakładamy odpowiedni warunek arytmetyczny lub geometryczny.
      </p>
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Wyznaczanie środkowego wyrazu ciągu arytmetycznego",
      description: "Wyznaczamy x tak, aby liczby 4, x, 12 były kolejnymi wyrazami ciągu arytmetycznego.",
      content: <BlockMath math={String.raw`(4,x,12)\quad\Longrightarrow\quad 2x=4+12\quad\Longrightarrow\quad x=8`} />,
    },
    {
      label: "Przykład 2",
      summary: "Wyznaczanie środkowego wyrazu ciągu geometrycznego",
      description: "Wyznaczamy dodatnie x tak, aby liczby 2, x, 18 były kolejnymi wyrazami ciągu geometrycznego.",
      content: <BlockMath math={String.raw`(2,x,18)\quad\Longrightarrow\quad x^2=2\cdot18\quad\Longrightarrow\quad x=6`} />,
    },
    {
      label: "Przykład 3",
      summary: "Tworzenie ciągu geometrycznego z wyrazów innego ciągu",
      description: "Obliczamy a₁ i a₄, a następnie wyznaczamy x w trójce (a₁, x, a₄).",
      content: (
        <div className="space-y-3">
          <p>Dla <InlineMath math="a_n=3n" /> mamy <InlineMath math="a_1=3" /> i <InlineMath math="a_4=12" />.</p>
          <BlockMath math={String.raw`(a_1,x,a_4)\ \text{geometryczny}\quad\Longrightarrow\quad x^2=3\cdot12=36\quad\Longrightarrow\quad x=6`} />
        </div>
      ),
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
